import React, { useEffect, useState } from "react";
import { Button, Form, DatePicker, Select } from "antd";
import useUsers from "../hooks/useUsers";
import PageDocumentation from "../components/PageDocumentation";

function SellerCommission() {
  const { users, getUsers } = useUsers();
  const [userId, setUserId] = useState(null);
  const [date, setDate] = useState(null);

  useEffect(() => {
    getUsers({ user_type: "SELLER" });
  }, []);

  useEffect(() => {
    console.log(users);
  }, [users]);

  return (
    <div className="w-100">
      <div className="flex justify-between items-center">
        <h1>Rendición Vendedores</h1>
        <div className="flex items-center gap-2">
          <PageDocumentation docKey="seller-commission" />
            <Button
            type="primary"
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_API_URL}admin/sellers/expenseseller/`,
                "_blank"
              );
            }}
          >
            Cargar gasto para vendedor
          </Button>
        </div>
      </div>
      <div className="flex justify-center">
        <Form layout="vertical" className="w-1/3">
          <Form.Item label="Fecha de ingreso del grupo/os" className="w-full">
            <DatePicker
              className="w-full"
              onChange={(date, dateString) => setDate(dateString)}
            />
          </Form.Item>
          <Form.Item label="Vendedor" className="w-full">
            <Select
              showSearch
              className="w-full"
              options={users.map((u) => ({
                value: u.id,
                label: `${u.firstName} ${u.lastName}`,
              }))}
              onChange={(value) => setUserId(value)}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            ></Select>
          </Form.Item>
          <Form.Item className="w-full">
            <Button
              type="primary"
              className="w-full"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_API_URL}passengers/seller-commission-pdf/${userId}/${date}/`,
                  "_blank"
                );
              }}
            >
              Descargar PDF del vendedor
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default SellerCommission;
